import {
  SAVE_DOMAIN_CHANGES_REQUEST,
  SAVE_DOMAIN_CHANGES_ERROR,
  SAVE_DOMAIN_CHANGES_SUCCESS,
  SAVE_IMAGES_CHANGES_REQUEST,
  SAVE_IMAGES_CHANGES_ERROR,
  SAVE_IMAGES_CHANGES_SUCCESS
} from '../../action/saveChanges/saveChangesConstants';

const initialState = {
  success: false,
  isLoading: false,
  hasError: false,
  updateDomainsData: null,
  updateImagesData: null
};

export const saveChanges = (state = initialState, action) => {
  const { type, updateDomainData, updateImagesData } = action;
  switch (type) {
    case SAVE_DOMAIN_CHANGES_REQUEST:
      return {
        ...state,
        hasError: false,
        isLoading: true
      };
    case SAVE_DOMAIN_CHANGES_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        success: true,
        updateDomainsData: updateDomainData
      };
    case SAVE_DOMAIN_CHANGES_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        success: false
      };
    case SAVE_IMAGES_CHANGES_REQUEST:
      return {
        ...state,
        hasError: false,
        isLoading: true
      };
    case SAVE_IMAGES_CHANGES_SUCCESS:
      return {
        ...state,
        hasError: false,
        isLoading: false,
        success: true,
        updateImagesData: updateImagesData
      };
    case SAVE_IMAGES_CHANGES_ERROR:
      return {
        ...state,
        hasError: true,
        isLoading: false,
        success: false
      };
    default:
      return state;
  }
};
